import React from 'react';
import Logo from 'components/common/Logo';
import { Outlet } from 'react-router-dom';
import './layout-tw.scss';

const AuthSimpleLayout = () => {
  return (
    <section className="tw-py-0">
      <div className="ptl-container">
        <div className="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-py-12">
          <div className="tw-w-full tw-max-w-[28rem]">
            <Logo />
            <div className="ptl-card">
              <div className="tw-p-6 sm:tw-p-8">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthSimpleLayout;
